import React from 'react';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './Gallery.scss';
import { Category } from '../data/Category';
import { Post } from '../data/Post';
import { connect } from 'react-redux';
import { fetchPosts, getCategoryPosts } from '../data/postsSlice';
import { State } from '../data/rootReducer';
import { AppConnectedProps } from '../data/store';

const connector = connect((state: State) => ({
  posts: state.posts,
}));

type GalleryProps = RouteComponentProps<{}> &
  AppConnectedProps<typeof connector> & {
    section: Category;
    density: 'many' | 'medium' | 'few';
  };

class Gallery extends React.Component<GalleryProps> {
  componentDidMount() {
    this.props.dispatch(fetchPosts(this.props.section));
  }

  render() {
    const posts = getCategoryPosts(this.props.posts, this.props.section);
    if (posts.status !== 'awake') {
      return <span>Loading...</span>;
    }
    const title = this.props.section[0].toLocaleUpperCase() + this.props.section.substring(1);
    return (
      <>
        <Helmet>
          <title>{title} - Who Is NemO'S?</title>
          <meta name="theme-color" content="#faf4ef" />
        </Helmet>
        <div className={'page-content gallery ' + this.densityClassname()}>
          {posts.item.map((post) => (
            <ThumbnailIcon key={post.slug} category={this.props.section} image={post} />
          ))}
        </div>
      </>
    );
  }

  densityClassname() {
    switch (this.props.density) {
      case 'few':
      case 'medium':
      case 'many':
        return this.props.density;
      default:
        throw new Error(`Bad density: ${this.props.density}`);
    }
  }
}

type ThumbnailIconProps = {
  category: Category;
  image: Post;
};

class ThumbnailIcon extends React.Component<ThumbnailIconProps> {
  render() {
    const link = this.props.category + '/' + this.props.image.slug;
    return (
      <div className="post-box">
        <article>
          <Link to={link}>
            <img src={this.props.image.thumbnail} alt={this.props.image.title} />
          </Link>
        </article>
      </div>
    );
  }
}

export default withRouter(connector(Gallery));
